module.exports = __webpack_public_path__ + "img/button-left-worls-oecd.0d54f370.png";